import React from "react";
import { TableOptionActionItemsConfig } from "./types";
import { TABLE_OPTION_ACTION_ITEM_HEIGHT } from "shared/utils/constants";

/**
 * Calculating this to add wrapped class when Table options are wrapping,
 * check all child element's offset top to determine whether wrapping or not.
 */
function isElementsWrapping(element?: HTMLDivElement) {
  let isWrapped = false;
  const childNodes = element?.childNodes;
  childNodes?.forEach((node: any) => {
    if (node?.offsetTop > TABLE_OPTION_ACTION_ITEM_HEIGHT) {
      isWrapped = true;
      return;
    }
  });

  return isWrapped;
}

export default function useTableOptionsService(props: TableOptionActionItemsConfig) {
  const optionRef = React.useRef<HTMLDivElement>(null);
  const [wrapped, setWrapped] = React.useState(false);
  const [expand, setExpand] = React.useState<Boolean>(false);

  const expandTable = React.useCallback(() => {
    setExpand(expand => !expand);
  }, []);

  React.useEffect(() => {
    if (optionRef.current) {
      setWrapped(isElementsWrapping(optionRef.current));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.left, props.right]);

  React.useEffect(() => {
    expand ? document.body.classList.add("isInFullView") : document.body.classList.remove("isInFullView");
  }, [expand]);

  return {
    optionRef,
    wrapped,
    expand,
    setExpand,
    expandTable
  };
}
